import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import jwtDecode from 'jwt-decode';

export const useCurrentUser = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: [QueryKeys.CurrentUser],
    queryFn: async () => {
      const auth0Token = await getAccessTokenSilently();
      const auth0UserId = auth0Token && jwtDecode<{ sub: string }>(auth0Token).sub;
      return await API.users.getCurrentUser(auth0UserId);
    },
    enabled: isAuthenticated,
  });
};
